import { findFirstBySearchMask } from '../core/imcmd/SearchMask.js';
import { Widget } from '../core/Widget.js';

// search-core/FilterOwner.ts
/**
 * Единое место разрешения адаптера владельца для виджетов.
 * Приоритеты:
 * 1) Явно переданный адаптер (explicit)
 * 2) Если owner — .im-table → TableFilterAdapter
 * 3) Скан всех живых виджетов внутри owner, реализующих FilterOwner.getFilterAdapter()
 * 4) Ошибка
 *
 * @param owner DOM-элемент владельца (например, .im-table)
 * @param explicit Явно переданный адаптер (если есть)
 * @param errorSource Метка для сообщения об ошибке (имя виджета-инициатора)
 */
function resolveFilterOwnerAdapter(owner, explicit, errorSource = "Widget") {
    // 1) явный адаптер
    if (explicit)
        return explicit;
    // 2) ищем живые виджеты внутри owner, реализующие FilterOwner
    const widgets = Widget.allOn(owner);
    for (const w of widgets) {
        const el = w.element;
        if (!el || !owner.contains(el))
            continue;
        const maybeOwner = w;
        if (maybeOwner && typeof maybeOwner.getFilterAdapter === "function") {
            try {
                const adapter = maybeOwner.getFilterAdapter();
                if (adapter)
                    return adapter;
            }
            catch {
                /* ignore и идём дальше */
            }
        }
    }
    // 4) ничего не нашли — ошибка
    throw new Error(`[${errorSource}] Owner adapter not found: pass options.ownerAdapter, provide FilterOwner.getFilterAdapter(), or use .im-table owner.`);
}
/**
    * Определяет владельца фильтра.
    * @param options Опции виджета фильтрации
    * @returns Найденный элемент-владелец
    * @throws Error если владелец не найден
    */
function resolveOwner(el, options, sourceKey) {
    // 1) Явно переданный ownerHost
    if (options.ownerHost instanceof HTMLElement) {
        return options.ownerHost;
    }
    // 2a) Если задана маска — ищем ближайшего родителя по маске
    if (options.ownerHostMask) {
        const byMask = findFirstBySearchMask(el, options.ownerHostMask);
        if (byMask)
            return byMask;
    }
    // 2b) Если по маске не нашли — ищем ближайший .im-table
    const imTable = el.closest('.im-table');
    if (imTable)
        return imTable;
    const byDefaultMask = findFirstBySearchMask(el, "[data-widget~='Search']^g");
    if (byDefaultMask)
        return byDefaultMask;
    // 3) Ничего не сработало — кидаем ошибку (позже можно расширить стратегию)
    throw new Error('[' + sourceKey + '] Owner host not found: specify ownerHostMask');
}

export { resolveFilterOwnerAdapter, resolveOwner };
